import { getAdminToken, setAdminToken, adminGet, adminPut, adminPost, adminDelete, getCSCId } from '../api'
import {
  ADMIN_LOGIN_URL,
  ADMIN_LOGOUT_URL,
  ADMIN_TERMINAL_URL,
  ADMIN_UI_CONFIG_URL,
  ADMIN_DEPARTURES_URL,
  ADMIN_CLOSED_DEPARTURES_URL,
  ADMIN_GET_PAIRS_URL,
} from '../../constants/admin/adminUrls'
import {
  ADMIN_LOGIN,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAILURE,
  ADMIN_GET_ALL_TERMINALS_SUCCESS,
  ADMIN_GET_ALL_TERMINALS_FAILURE,
  ADMIN_GET_ALL_TERMINALS,
  ADMIN_SET_ACTIVE_TERMINAL,
  ADMIN_SAVE_TERMINAL,
  ADMIN_SAVE_TERMINAL_SUCCESS,
  ADMIN_SAVE_TERMINAL_FAILURE,
  ADMIN_SET_LOGIN_ERROR_MESSAGE,
  ADMIN_GET_UI_CONFIG,
  ADMIN_SET_UI_CONFIG,
  ADMIN_GET_UI_CONFIG_SUCCESS,
  ADMIN_GET_UI_CONFIG_FAILURE,
  ADMIN_SET_UI_CONFIG_FAILURE,
  ADMIN_GET_DEPARTURES,
  ADMIN_GET_DEPARTURES_SUCCESS,
  ADMIN_GET_DEPARTURES_FAILURE,
  ADMIN_UPDATE_DEPARTURE,
  ADMIN_UPDATE_DEPARTURE_FAILURE,
  ADMIN_UPDATE_DEPARTURE_SUCCESS,
  ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS,
  ADMIN_TOGGLE_OPENING_TERMINALS,
  ADMIN_TOGGLE_OPENING_DEPARTURES,
  ADMIN_GET_PAIRS,
  ADMIN_GET_PAIRS_FAILURE,
  ADMIN_GET_PAIRS_SUCCESS,
} from '../../constants/admin/adminActions'
import { AdminUI } from '../../constants/admin/adminUi'
import { setAdminUIAction } from './adminUi'
import { Log } from '../../utilities/logger'
import { composeTerminals } from '../../types/terminal'
import { jsonAllTerminalsParse, jsonTerminalSerialization } from '../../types/converter'
import { composeUiConfig, UiConfig } from '../../types/uiConfig'
import { DepartureWithClosedCheckIn } from '../../components/Admin/Departures'

export const getAllTerminalsAction: any = () => async (dispatch: any) => {
  try {
    if (!getAdminToken()) {
      dispatch({ type: ADMIN_LOGIN_FAILURE })
    }
    dispatch({ type: ADMIN_GET_ALL_TERMINALS })

    const response = await adminGet(ADMIN_TERMINAL_URL)
    dispatch({ type: ADMIN_LOGIN_SUCCESS })
    dispatch({
      type: ADMIN_GET_ALL_TERMINALS_SUCCESS,
      payload: composeTerminals(jsonAllTerminalsParse(response.data)),
    })
  } catch (e) {
    Log('get terminals error', e)
    dispatch({ type: ADMIN_GET_ALL_TERMINALS_FAILURE })
    if (e && e.response && e.response.status && e.response.status === 401) {
      dispatch({ type: ADMIN_LOGIN_FAILURE })
    }
  }
}

export const getPierShipPairsAction: any = () => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_GET_PAIRS })
    
    const response = await adminGet(ADMIN_GET_PAIRS_URL)
    if (!response.data) {
      throw new Error('get pairs error')
    }
    dispatch({ type: ADMIN_GET_PAIRS_SUCCESS, payload: response.data })
  } catch (e) {
    Log('get Departures error', e)
    dispatch({ type: ADMIN_GET_PAIRS_FAILURE })
  }
}

export const activeTerminalAction: any = (terminal: any) => ({ type: ADMIN_SET_ACTIVE_TERMINAL, payload: terminal })
export const saveTerminalAction: any = (terminal: any) => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_SAVE_TERMINAL })
    await adminPut(ADMIN_TERMINAL_URL, jsonTerminalSerialization(terminal))
    dispatch({ type: ADMIN_SAVE_TERMINAL_SUCCESS, payload: terminal })
    dispatch(setAdminUIAction(AdminUI.ALL_TERMINALS))
  } catch (e) {
    Log('save terminal edited fields error', e)
    dispatch({ type: ADMIN_SAVE_TERMINAL_FAILURE })
  }
}

export const getUIConfigAction: any = () => async (dispatch: any) => {
  try {
    if (!getAdminToken()) {
      dispatch({ type: ADMIN_LOGIN_FAILURE })
    }
    dispatch({ type: ADMIN_GET_UI_CONFIG })

    const response = await adminGet(ADMIN_UI_CONFIG_URL)
    const uiConfig = composeUiConfig(response.data)
    if (!uiConfig) {
      throw new Error('uiConfig error')
    }
    dispatch({
      type: ADMIN_GET_UI_CONFIG_SUCCESS,
      payload: uiConfig,
    })
  } catch (e) {
    Log('get ui config error', e)
    dispatch({ type: ADMIN_GET_UI_CONFIG_FAILURE })
    if (e && e.response && e.response.status && e.response.status === 401) {
      dispatch({ type: ADMIN_LOGIN_FAILURE })
    }
  }
}

export const setUIConfigAction: any = (uiConfig: UiConfig) => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_SET_UI_CONFIG })
    await adminPut(ADMIN_UI_CONFIG_URL, uiConfig)
    dispatch({ type: ADMIN_GET_UI_CONFIG_SUCCESS, payload: uiConfig })
  } catch (e) {
    Log('save uiConfig edited fields error', e)
    dispatch({ type: ADMIN_SET_UI_CONFIG_FAILURE })
  }
}

export const getDeparturesAction: any = () => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_GET_DEPARTURES })

    const response = await adminGet(ADMIN_DEPARTURES_URL)
    if (!response.data) {
      throw new Error('departures error')
    }
    const sortedByDateFrom = response.data.sort(
      (a: { dateFrom: number }, b: { dateFrom: number }) => a.dateFrom - b.dateFrom,
    )
    dispatch({ type: ADMIN_GET_DEPARTURES_SUCCESS, payload: sortedByDateFrom })
  } catch (e) {
    Log('get Departures error', e)
    dispatch({ type: ADMIN_GET_DEPARTURES_FAILURE })
  }
}

export const closeDepartureAction: any = (departure: DepartureWithClosedCheckIn) => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_UPDATE_DEPARTURE })
    const request = { dateFrom: departure.dateFrom, sailFromRefId: departure.sailFromRefId }
    
    const response = await adminPost(ADMIN_CLOSED_DEPARTURES_URL, request)
    if (response.status === 200) {
      dispatch({
        type: ADMIN_UPDATE_DEPARTURE_SUCCESS,
        payload: { sailFromRefId: departure.sailFromRefId, closedCheckIn: true },
      })
    } else {
      dispatch({ type: ADMIN_UPDATE_DEPARTURE_FAILURE })
      Log("don't get updated list of departures")
    }
  } catch (e) {
    Log('post departure error', e)
    dispatch({ type: ADMIN_UPDATE_DEPARTURE_FAILURE })
  }
}
export const openDepartureAction: any = (departure: DepartureWithClosedCheckIn) => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_UPDATE_DEPARTURE })
    const response = await adminDelete(ADMIN_CLOSED_DEPARTURES_URL + `/${departure.sailFromRefId}`)
    if (response.status < 300) {
      dispatch({
        type: ADMIN_UPDATE_DEPARTURE_SUCCESS,
        payload: { sailFromRefId: departure.sailFromRefId, closedCheckIn: false },
      })
    } else {
      dispatch({ type: ADMIN_UPDATE_DEPARTURE_FAILURE })
      Log("don't get updated list of departures")
    }
  } catch (e) {
    Log('delete departure error', e)
    dispatch({ type: ADMIN_UPDATE_DEPARTURE_FAILURE })
  }
}

export const loginAction: any = (request: { username: string; password: string }) => async (dispatch: any) => {
  try {
    dispatch({ type: ADMIN_LOGIN })
    const response = await adminPost(ADMIN_LOGIN_URL, request)
    if (response && response.data && response.data.token) {
      setAdminToken(response.data.token)
      dispatch(getPierShipPairsAction())
      dispatch(getAllTerminalsAction())
      dispatch({ type: ADMIN_LOGIN_SUCCESS })
      dispatch(setAdminUIAction(AdminUI.ALL_TERMINALS))
    } else {
      dispatch({ type: ADMIN_LOGIN_FAILURE })
    }
  } catch (e) {
    Log('admin login error', e)
    dispatch({ type: ADMIN_LOGIN_FAILURE })
    dispatch({ type: ADMIN_SET_LOGIN_ERROR_MESSAGE })
  }
}

export const logoutAction: any = () => async (dispatch: any) => {
  try {
    // todo clear cookies
    setAdminToken('')
    await adminPost(ADMIN_LOGOUT_URL, {})
  } catch (e) {
    Log('logout error', e)
  }
  dispatch(setAdminUIAction(AdminUI.LOGIN))
}

export const setToggleOpeningLocationSettingsAction: any = () => async (dispatch: any) => {
  dispatch({ type: ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS })
}
export const setToggleOpeningTerminalsAction: any = () => async (dispatch: any) => {
  dispatch({ type: ADMIN_TOGGLE_OPENING_TERMINALS })
}
export const setToggleOpeningDeparturesAction: any = () => async (dispatch: any) => {
  dispatch({ type: ADMIN_TOGGLE_OPENING_DEPARTURES })
}
